import { useEffect, useState } from 'react'
import AdminLayout from '../../components/AdminLayout'
import { supabase } from '../../lib/supabase'

const fmt = (n) => Number(n || 0).toLocaleString('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export default function ReportesDGI() {
  const [tab, setTab] = useState('iva')
  return (
    <AdminLayout>
      <div className="dgi-wrap">
        <div className="dgi-headline">
          <h1>Declaraciones DGI</h1>
          <p>Liquidación mensual de IVA (Form 1387), anticipo IRAE y Formulario 2181 NO CEDE anual.</p>
        </div>
        <div className="dgi-tabs">
          <button className={tab === 'iva' ? 'active' : ''} onClick={() => setTab('iva')}>📋 Form 1387 (IVA mensual)</button>
          <button className={tab === 'irae' ? 'active' : ''} onClick={() => setTab('irae')}>📈 Anticipo IRAE</button>
          <button className={tab === 'f2181' ? 'active' : ''} onClick={() => setTab('f2181')}>📑 Form 2181 (NO CEDE anual)</button>
        </div>
        {tab === 'iva' && <Form1387 />}
        {tab === 'irae' && <AnticipoIRAE />}
        {tab === 'f2181' && <Form2181 />}
      </div>
      <style>{CSS}</style>
    </AdminLayout>
  )
}

// ════════ FORMULARIO 2181 NO CEDE ════════

export function Form2181() {
  const [anio, setAnio] = useState(() => String(new Date().getFullYear()))
  const [descargando, setDescargando] = useState(false)
  const [mensaje, setMensaje] = useState(null)

  async function descargar() {
    setDescargando(true); setMensaje(null)
    try {
      // Edge function devuelve .txt directo si hay datos, JSON si está vacío
      const { data: { session } } = await supabase.auth.getSession()
      const url = `${import.meta.env.VITE_SUPABASE_URL || ''}/functions/v1/export-f2181`
      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session?.access_token}`,
        },
        body: JSON.stringify({ periodo: anio }),
      })
      const ct = resp.headers.get('content-type') || ''
      if (ct.startsWith('text/plain')) {
        const txt = await resp.text()
        const filas = resp.headers.get('X-Filas-Generadas')
        const blob = new Blob([txt], { type: 'text/plain;charset=utf-8' })
        const a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.download = `Formulario 2181 - Limpack ${anio}.txt`
        document.body.appendChild(a); a.click(); a.remove()
        setMensaje({ tipo: 'ok', txt: `Descargado: ${filas} líneas para ${anio}.` })
      } else {
        const j = await resp.json()
        if (j.ok) setMensaje({ tipo: 'warn', txt: j.nota || `Sin líneas con literal tributario en ${anio}.` })
        else setMensaje({ tipo: 'error', txt: j.error || 'Error generando F2181' })
      }
    } catch (e) {
      setMensaje({ tipo: 'error', txt: e.message })
    } finally {
      setDescargando(false)
    }
  }

  return (
    <div>
      <div className="dgi-toolbar">
        <label className="dgi-fil"><span>Año fiscal</span><input type="number" min="2026" max="2099" value={anio} onChange={e => setAnio(e.target.value)} /></label>
        <button className="dgi-btn-primary" onClick={descargar} disabled={descargando}>
          {descargando ? '⏳ Generando…' : '⬇ Descargar .txt'}
        </button>
      </div>

      {mensaje && (
        <div className={`dgi-banner dgi-banner-${mensaje.tipo}`}>{mensaje.txt}</div>
      )}

      <div className="dgi-info">
        <strong>📚 Formulario 2181 — NO CEDE</strong>
        <p>
          Mientras Limpack sea <b>NO CEDE</b>, al cierre de cada año se genera este <code>.txt</code> con todas las operaciones gravadas/exentas del período.
          DGI lo procesa para la declaración jurada anual 2178.
        </p>
        <p>
          <b>Formato (Roberto):</b> 7 campos separados por <code>;</code>:<br />
          <code>RUT Limpack(12) ; "02181" ; Periodo(YYYYMM) ; RUT informado(12) ; Factura(YYYYMM) ; Literal(3) ; Importe(12)</code>
        </p>
        <p>
          <b>Literales</b>: 501 PF · 502 empresas IVA básica · 503 empresas IVA mínima · 504 exentos · 505 IVA básica compras · 506 IVA mínima compras.
        </p>
        <p>
          <b>Pendiente:</b> linkear cada línea con proveedor/cliente para extraer RUT real. Hoy el campo "RUT informado" sale como <code>000000000000</code> placeholder.
        </p>
      </div>
    </div>
  )
}

export function Form1387() {
  const [mes, setMes] = useState(() => new Date().toISOString().slice(0, 7))
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => { cargar() }, [mes])
  async function cargar() {
    setLoading(true)
    const { data: r } = await supabase.rpc('get_iva_form_1387', { p_mes: `${mes}-01` })
    setData(r)
    setLoading(false)
  }

  if (loading) return <div className="dgi-loading">Cargando…</div>
  if (!data) return <div className="dgi-empty">Sin datos</div>

  const debito = data.iva_debito
  const credito = data.iva_credito
  const saldo = Number(data.saldo_periodo)

  return (
    <>
      <div className="dgi-toolbar">
        <label className="dgi-fil"><span>Mes</span><input type="month" value={mes} onChange={e => setMes(e.target.value)} /></label>
        <button className="dgi-btn-ghost" onClick={() => alert('Próximamente: exportar a Excel para presentar en DGI')}>📊 Exportar</button>
      </div>

      <div className="dgi-saldo-card" style={{ background: saldo > 0 ? '#fef2f2' : saldo < 0 ? '#f0fdf4' : '#f8fafc', borderColor: saldo > 0 ? '#fca5a5' : saldo < 0 ? '#86efac' : '#cbd5e1' }}>
        <div className="dgi-saldo-label">Saldo del período</div>
        <div className="dgi-saldo-monto" style={{ color: saldo > 0 ? '#dc2626' : saldo < 0 ? '#16a34a' : '#64748b' }}>
          ${fmt(Math.abs(saldo))}
        </div>
        <div className="dgi-saldo-estado">
          {saldo > 0 ? '⚠ A pagar a DGI' : saldo < 0 ? '✓ A favor (saldo se traslada al próximo mes)' : 'Sin saldo'}
        </div>
      </div>

      <div className="dgi-grid">
        <div className="dgi-bloque">
          <h3>🔼 IVA Débito (recaudado en ventas)</h3>
          <table className="dgi-tabla">
            <tbody>
              <tr><td>Base imponible 22%</td><td className="r">${fmt(debito.ventas_base_22)}</td></tr>
              <tr><td>IVA débito 22%</td><td className="r" style={{ color: '#16a34a' }}>${fmt(debito.ventas_iva_22)}</td></tr>
              <tr><td>Base imponible 10%</td><td className="r">${fmt(debito.ventas_base_10)}</td></tr>
              <tr><td>IVA débito 10%</td><td className="r" style={{ color: '#16a34a' }}>${fmt(debito.ventas_iva_10)}</td></tr>
              <tr><td>Ventas exentas</td><td className="r">${fmt(debito.ventas_exentas)}</td></tr>
              <tr className="dgi-total"><td><b>Total IVA Débito</b></td><td className="r"><b>${fmt(debito.total)}</b></td></tr>
            </tbody>
          </table>
        </div>

        <div className="dgi-bloque">
          <h3>🔽 IVA Crédito (pagado en compras)</h3>
          <table className="dgi-tabla">
            <tbody>
              <tr><td>Base imponible 22%</td><td className="r">${fmt(credito.compras_base_22)}</td></tr>
              <tr><td>IVA crédito 22%</td><td className="r" style={{ color: '#dc2626' }}>${fmt(credito.compras_iva_22)}</td></tr>
              <tr><td>Base imponible 10%</td><td className="r">${fmt(credito.compras_base_10)}</td></tr>
              <tr><td>IVA crédito 10%</td><td className="r" style={{ color: '#dc2626' }}>${fmt(credito.compras_iva_10)}</td></tr>
              <tr><td colSpan={2}>&nbsp;</td></tr>
              <tr className="dgi-total"><td><b>Total IVA Crédito</b></td><td className="r"><b>${fmt(credito.total)}</b></td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="dgi-bloque" style={{ marginTop: 16 }}>
        <h3>📥 Retenciones IVA recibidas (Decreto 19.210)</h3>
        <div className="dgi-retencion">
          <div>Total retenciones del período</div>
          <div className="dgi-retencion-monto">${fmt(data.retenciones_recibidas)}</div>
          <div style={{ fontSize: 12, color: '#64748b' }}>Estas retenciones se descuentan del saldo a pagar</div>
        </div>
      </div>

      <div className="dgi-formula">
        <h3>💡 Fórmula del saldo</h3>
        <div className="dgi-formula-row">
          <span>IVA Débito</span>
          <span className="dgi-op">−</span>
          <span>IVA Crédito</span>
          <span className="dgi-op">−</span>
          <span>Retenciones recibidas</span>
          <span className="dgi-op">=</span>
          <span className="dgi-op-result">Saldo</span>
        </div>
        <div className="dgi-formula-row" style={{ color: '#475569', fontWeight: 700 }}>
          <span>${fmt(debito.total)}</span>
          <span className="dgi-op">−</span>
          <span>${fmt(credito.total)}</span>
          <span className="dgi-op">−</span>
          <span>${fmt(data.retenciones_recibidas)}</span>
          <span className="dgi-op">=</span>
          <span className="dgi-op-result" style={{ color: saldo > 0 ? '#dc2626' : '#16a34a' }}>${fmt(saldo)}</span>
        </div>
      </div>

      <div className="dgi-info">
        <strong>📅 Vencimiento Form 1387:</strong> presentación entre los días 13 y 27 del mes siguiente (varía según último dígito RUT). Pago: hasta el último día hábil del mes.
      </div>
    </>
  )
}

export function AnticipoIRAE() {
  const [mes, setMes] = useState(() => new Date().toISOString().slice(0, 7))
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => { cargar() }, [mes])
  async function cargar() {
    setLoading(true)
    const { data: r } = await supabase.rpc('get_anticipo_irae', { p_mes: `${mes}-01` })
    setData(r)
    setLoading(false)
  }

  if (loading) return <div className="dgi-loading">Cargando…</div>
  if (!data) return <div className="dgi-empty">Sin datos</div>

  return (
    <>
      <div className="dgi-toolbar">
        <label className="dgi-fil"><span>Mes</span><input type="month" value={mes} onChange={e => setMes(e.target.value)} /></label>
      </div>

      <div className="dgi-saldo-card" style={{ background: '#eff6ff', borderColor: '#bfdbfe' }}>
        <div className="dgi-saldo-label">Anticipo IRAE sugerido para este mes</div>
        <div className="dgi-saldo-monto" style={{ color: '#1e40af' }}>${fmt(data.anticipo_mensual_sugerido)}</div>
        <div className="dgi-saldo-estado">1/12 del IRAE proyectado anual (25% sobre utilidad proyectada)</div>
      </div>

      <div className="dgi-grid">
        <div className="dgi-bloque">
          <h3>📊 Acumulado del ejercicio</h3>
          <table className="dgi-tabla">
            <tbody>
              <tr><td>Ejercicio</td><td className="r">{data.ejercicio.inicio} → {data.ejercicio.fin}</td></tr>
              <tr><td>Meses transcurridos</td><td className="r">{data.ejercicio.meses_transcurridos}</td></tr>
              <tr><td colSpan={2}>&nbsp;</td></tr>
              <tr><td>Ingresos acumulados</td><td className="r" style={{ color: '#16a34a' }}>${fmt(data.acumulado.ingresos)}</td></tr>
              <tr><td>Egresos deducibles acumulados</td><td className="r" style={{ color: '#dc2626' }}>${fmt(data.acumulado.egresos)}</td></tr>
              <tr className="dgi-total"><td><b>Utilidad acumulada</b></td><td className="r"><b>${fmt(data.acumulado.utilidad)}</b></td></tr>
            </tbody>
          </table>
        </div>

        <div className="dgi-bloque">
          <h3>🔮 Proyección anual</h3>
          <table className="dgi-tabla">
            <tbody>
              <tr><td>Utilidad acumulada</td><td className="r">${fmt(data.acumulado.utilidad)}</td></tr>
              <tr><td>÷ Meses transcurridos</td><td className="r">{data.ejercicio.meses_transcurridos}</td></tr>
              <tr><td>× 12 meses (proyección)</td><td className="r">${fmt(data.proyeccion_anual.utilidad)}</td></tr>
              <tr><td>× 25% (tasa IRAE)</td><td className="r" style={{ color: '#7c3aed' }}>${fmt(data.proyeccion_anual.irae_25_pct)}</td></tr>
              <tr className="dgi-total"><td><b>÷ 12 = anticipo mensual</b></td><td className="r"><b>${fmt(data.anticipo_mensual_sugerido)}</b></td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="dgi-bloque" style={{ marginTop: 16 }}>
        <h3>💵 Estado de anticipos pagados</h3>
        <table className="dgi-tabla">
          <tbody>
            <tr><td>Anticipos pagados acumulados</td><td className="r" style={{ color: '#16a34a' }}>${fmt(data.anticipos_pagados_acumulados)}</td></tr>
            <tr><td>Anticipos que deberían haberse pagado</td><td className="r">${fmt(data.anticipo_mensual_sugerido * data.ejercicio.meses_transcurridos)}</td></tr>
            <tr className="dgi-total">
              <td><b>Diferencia</b></td>
              <td className="r" style={{ color: Number(data.diferencia) > 0 ? '#dc2626' : '#16a34a' }}>
                <b>${fmt(data.diferencia)}</b>
                {Number(data.diferencia) > 0 ? ' (debe pagarse)' : Number(data.diferencia) < 0 ? ' (a favor)' : ''}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="dgi-info">
        <strong>📚 Cómo funciona el anticipo IRAE:</strong>
        <ul>
          <li>El IRAE es <b>25% sobre la utilidad neta anual</b> del ejercicio.</li>
          <li>DGI exige <b>pagos a cuenta mensuales</b> que se descuentan del IRAE final.</li>
          <li>Este reporte calcula la sugerencia anualizando la utilidad acumulada del ejercicio.</li>
          <li>Roberto valida y ajusta según la realidad del negocio (estacionalidad, etc).</li>
          <li>El anticipo va al <b>activo</b> (cuenta 1.1.03.01), <b>no es gasto deducible</b>.</li>
        </ul>
      </div>
    </>
  )
}

export const CSS = `
.dgi-wrap { padding: 16px 20px 32px; max-width: 1400px; margin: 0 auto }
.dgi-headline h1 { font-size: 26px; font-weight: 900; color: #1A3461; margin: 0 0 4px; letter-spacing: -.02em }
.dgi-headline p { font-size: 13px; color: #64748b; margin: 0 0 16px }
.dgi-tabs { display: flex; gap: 4px; margin-bottom: 16px; border-bottom: 2px solid #e2e8f0 }
.dgi-tabs button { background: transparent; border: 0; padding: 10px 16px; font-size: 13px; font-weight: 700; color: #64748b; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -2px; font-family: inherit }
.dgi-tabs button.active { color: #1A3461; border-bottom-color: #1A3461 }

.dgi-toolbar { display: flex; gap: 10px; align-items: flex-end; margin-bottom: 14px; flex-wrap: wrap }
.dgi-fil { display: flex; flex-direction: column; gap: 3px }
.dgi-fil span { font-size: 11px; color: #475569; font-weight: 700; text-transform: uppercase; letter-spacing: .04em }
.dgi-fil input { padding: 7px 10px; border: 1px solid #cbd5e1; border-radius: 7px; font-size: 13px; font-family: inherit }
.dgi-btn-ghost { padding: 7px 12px; background: transparent; border: 1px solid #cbd5e1; color: #475569; border-radius: 7px; font-size: 12px; font-weight: 700; cursor: pointer; font-family: inherit }

.dgi-loading, .dgi-empty { padding: 40px; text-align: center; color: #94a3b8 }

.dgi-saldo-card { border: 2px solid; border-radius: 14px; padding: 18px 24px; margin-bottom: 18px; text-align: center }
.dgi-saldo-label { font-size: 12px; color: #475569; text-transform: uppercase; font-weight: 800; letter-spacing: .04em }
.dgi-saldo-monto { font-size: 36px; font-weight: 900; margin: 6px 0; letter-spacing: -.02em }
.dgi-saldo-estado { font-size: 13px; color: #475569; font-weight: 700 }

.dgi-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px }
@media (max-width: 740px) { .dgi-grid { grid-template-columns: 1fr } }

.dgi-bloque { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 16px }
.dgi-bloque h3 { margin: 0 0 12px; font-size: 14px; font-weight: 900; color: #1A3461; letter-spacing: -.01em }

.dgi-tabla { width: 100%; border-collapse: collapse; font-size: 13px }
.dgi-tabla td { padding: 6px 8px; border-bottom: 1px solid #f1f5f9; color: #1A3461 }
.dgi-tabla td.r { text-align: right; font-variant-numeric: tabular-nums }
.dgi-tabla tr.dgi-total td { border-bottom: 0; border-top: 2px solid #1A3461; padding-top: 8px; background: #f8fafc }

.dgi-retencion { display: flex; justify-content: space-between; align-items: center; padding: 12px; background: #fef3c7; border-radius: 8px; flex-wrap: wrap; gap: 12px }
.dgi-retencion-monto { font-size: 24px; font-weight: 900; color: #92400e }

.dgi-formula { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 16px; margin-top: 16px }
.dgi-formula h3 { margin: 0 0 12px; font-size: 14px; font-weight: 900; color: #1A3461 }
.dgi-formula-row { display: flex; gap: 12px; align-items: center; font-size: 14px; color: #1A3461; flex-wrap: wrap; margin-bottom: 6px }
.dgi-op { color: #94a3b8 }
.dgi-op-result { font-weight: 900 }

.dgi-info { margin-top: 16px; padding: 14px 18px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px; font-size: 12.5px; color: #1e3a8a; line-height: 1.6 }
.dgi-info strong { font-size: 13px }
.dgi-info ul { margin: 8px 0; padding-left: 22px }
.dgi-info b { color: #1e40af }
.dgi-info code { background: #dbeafe; padding: 1px 5px; border-radius: 4px; font-size: 11px; font-family: ui-monospace, Menlo, monospace }

.dgi-banner { padding: 10px 14px; border-radius: 8px; font-size: 13px; margin-bottom: 12px; font-weight: 600 }
.dgi-banner-ok { background: #dcfce7; border: 1px solid #86efac; color: #166534 }
.dgi-banner-warn { background: #fef3c7; border: 1px solid #fde68a; color: #92400e }
.dgi-banner-error { background: #fee2e2; border: 1px solid #fca5a5; color: #991b1b }

.dgi-btn-primary { background: #1A3461; color: #fff; border: 0; padding: 8px 18px; border-radius: 8px; font-size: 13px; font-weight: 800; cursor: pointer; font-family: inherit }
.dgi-btn-primary:hover { background: #0f2147 }
.dgi-btn-primary:disabled { background: #94a3b8; cursor: not-allowed }
`
